export default __webpack_public_path__ + "static/media/example.b4f475ec.md";